import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { MdFilterList, MdCheckBoxOutlineBlank, MdCheckBox, MdClose } from 'react-icons/md'
import { useRouter } from 'next/router'
import { Typography } from 'common/typography'
import { TransparentButton } from 'common/button'
import filters from 'projects/filter/filter-options.json'
import AsideMenu from './aside-menu'

const ProjectsFilterStyled = styled.div`
  .filter-menu-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .filter-list {
    padding: 1rem 0;
    border-bottom: 1px solid #C2C2C2;
  }
  .filter-options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-block-start: 1rem;
  }
  .filter-menu {
    padding: 0;
  }
  .filter-item {
    gap: .25rem;
    svg {
      margin: 0;
    }
  }
  @media (min-width: 1024px) {
    .filter-options {
      flex-direction: row;
    }
  }
`

function ProjectsFilter() {
  const router = useRouter()
  const [show, setShow] = useState(false)
  const [checked, setChecked] = useState('')

  useEffect(() => {
    const querys = Object.values(router.query)
    if (!querys.includes(checked)) {
      setChecked('')
    }
  }, [router.query])

  const handleOption = (param, type) => {
    const url = window.location.pathname
    const querys = { ...router.query }
    if (param !== checked) {
      setChecked(param)
      querys[type] = param
    } else {
      setChecked('')
      delete querys[type]
    }
    router.replace({
      pathname: url,
      query: querys,
      shallow: true,
      scroll: false,
    })
  }

  return (
    <>
      <TransparentButton onClick={() => setShow(true)}>
        <MdFilterList size={20} />
        Filtrar
      </TransparentButton>
      <AsideMenu show={show} setShow={setShow}>
        <ProjectsFilterStyled>
          <div className="filter-menu-title">
            <Typography font="headline6">Filtrar por</Typography>
            <TransparentButton onClick={() => setShow(false)}>
              <MdClose size="24" />
            </TransparentButton>
          </div>
          <menu className="filter-menu">
            {filters.map(({ title, options, id, type }) => (
              <div key={id} className="filter-list">
                <Typography font="regularBold">{title}</Typography>
                <ul className="filter-options">
                  {options.map(({ param, option }) => (
                    <li key={param}>
                      <TransparentButton className="filter-item" onClick={() => handleOption(param, type)}>
                        {checked === param ? (
                          <MdCheckBox color="var(--white)" size={24} />
                        ) : (
                          <MdCheckBoxOutlineBlank color="var(--white)" size={24} />
                        )}
                        {option}
                      </TransparentButton>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </menu>
        </ProjectsFilterStyled>
      </AsideMenu>
    </>
  )
}

export default ProjectsFilter
